import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';

import { getOSHData } from '../../api';

const Publications = props => {

    const [pageOfItems, setPageOfItems] = useState([]);
    const [matrixPageData, setMatrixPageData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [filters, setFilters] = useState({
        checks: [],
        searchBar: ''
    });

    useEffect(() => {
        // Update the title for the page
		document.title = "Publications" +  " - " + props.literals.L22020 + " - " + props.literals.L363;

        setIsFetching(true);
        try
        {
            getOSHData('PUBLICATIONS')
            .then((res) => {
                // Filter the returned elements so there are no elements with empty values for all the texts
                setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
            })
        }
        catch (error) 
        {
			console.log('Error fetching selector countries:', error)
		} 
        finally 
        {
            setIsFetching(false);
		}
    }, [])

    useEffect(() => {
        setIsFetching(true);
        try {
            getOSHData('PUBLICATIONS', filters)
            .then((res) => {
                // Filter the returned elements so there are no elements with empty values for all the texts
                setMatrixPageData( res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != "") );
            })
        } catch (error) {
            console.log('Error fetching data', error)
        } finally {
            setIsFetching(false);
        }
    }, [filters])

    const handleCallbackSearch = (searchCallback) => {
        setFilters( {...filters, searchBar: searchCallback } );
    }

    const handleCallbackInstitution = (institutionCallback) => {
        const checkFilter = filters.checks.find((data) => data.id == institutionCallback.id);
		const checks = filters.checks;
		if (!checkFilter) {
            setFilters( {...filters, checks: [...filters.checks, {...institutionCallback, check: true } ] } );
		} else {
			const index = filters.checks.findIndex((data) => data.id == institutionCallback.id);
			const newArray = filters.checks;
			newArray.splice(index, 1);
            setFilters( {...filters, checks: newArray } );
		}
    }

    const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems);
	}

    return (
        <div className='publications'>
            <AdviceSection literals={ props.literals } section={["resources","publications"]} methodologyData={{section: 'resources', subsection: 'publications', indicator: 410}} />

            <section className='container'>

                { /** Filters Component */}
                <SelectFilters
                    literals={ props.literals }
                    onSearchbarClick={ handleCallbackSearch }
                    onClickInstitution={ handleCallbackInstitution }
                    selectedFilters={ filters }
                    filterCategory={ 'publication' }
                />

                <div className='container'>
                    {/* Cards Component */}
                    <div className='matrix--elements--wrapper'>
                        { pageOfItems.length > 0 ? (
                            pageOfItems.map((data, index) => {
                                const position = matrixPageData.findIndex((matrixData) => matrixData == data);
                                const id = `${index}-${props.literals["L"+data.text1]}-${position}`

                                return <Cards key={id} idCard={id} countryData={data} literals={props.literals} cardType={'publication'}/>
                            })
                        ) : (<span>{props.literals.L20706}</span>)}                            
                    </div>

                    {/* PAGINATION */}
                    <Pagination items={matrixPageData} onChangePage={onChangePage} />
                </div>                
            </section>
        </div>
    )
}

Publications.displayName = 'Publications';

export default connect(null, null)(Publications);